export const colorScheema = [
  '#FB7B34',
  '#CD6D38',
  '#9F5E3B',
  '#72513F',
  '#6467C3',
  '#5C5EA3',
  '#545482',
  '#4C4C63',
  '#81AB64',
  '#72915C',
  '#627653',
  '#535D4B',
];
